module.exports = __webpack_public_path__ + "static/media/playIconTextBlue.44f07d18.svg";